import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * DefaultWelcome — start screen shown inside a new (empty) conversation
 * when the user is in the default chat mode or any agent that doesn't
 * have its own custom welcome screen yet.
 *
 * To add a custom welcome screen for a new agent, create a sibling
 * component (e.g. MyAgentWelcome.tsx) and wire it up in ChatContainer.tsx.
 */
const DefaultWelcome: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      width="100%"
      height="100%"
      gap={1}
      px={3}
      pt={8}
    >
      <Box
        component="img"
        src="/images/Bolt - 435x187.png"
        alt="Bolt Logo"
        sx={{
          width: { xs: '250px', sm: '380px' },
          height: 'auto',
          mb: 1,
        }}
      />
      <Typography
        variant="h5"
        fontWeight={600}
        color="text.primary"
        textAlign="center"
        sx={{ mb: 0.5 }}
      >
        Build Organize Learn Transform
      </Typography>
      <Typography
        variant="h6"
        fontWeight={400}
        color="text.secondary"
        textAlign="center"
        sx={{ mb: 10 }}
      >
        The Bossard AI Platform
      </Typography>
      <Typography
        variant="h6"
        fontWeight={400}
        color="text.primary"
        textAlign="center"
      >
        Let's bolt right into it - what do you need?
      </Typography>
    </Box>
  );
};

export default DefaultWelcome;
